import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { AuthShell } from "../components/AuthShell";
import { api, PRODUCT_LABEL } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentResult({ success = false }) {
  const [sp] = useSearchParams();
  const [state, setState] = useState(success ? "checking" : "cancelled");
  const [product, setProduct] = useState("");
  const { refresh } = useAuth();
  useEffect(() => {
    if (!success) return;
    const paypalId = sp.get("token");
    const sid = sp.get("session_id");
    let n = 0, stop = false;
    const poll = async () => {
      if (stop) return;
      try {
        const { data } = paypalId ? await api.post(`/payments/paypal/capture/${paypalId}`) : await api.get(`/payments/status/${sid}`);
        setProduct(data.product);
        if (data.payment_status === "paid") { setState("paid"); refresh(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { setState("failed"); return; }
      if (++n < 15) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => { stop = true; };
  }, [success, sp, refresh]);

  const map = {
    checking: [Loader2, "confirming payment…", "hang tight, talking to the bank.", "animate-spin text-zinc-400"],
    paid: [CheckCircle2, "unlocked.", `${PRODUCT_LABEL[product] || "Your purchase"} is now active on your account.`, "text-[#ff3b91]"],
    failed: [XCircle, "payment failed", "Nothing was charged. Try again from the store.", "text-red-400"],
    timeout: [Loader2, "still processing", "This can take a minute. Refresh the store shortly.", "text-zinc-400"],
    cancelled: [XCircle, "checkout cancelled", "No worries — nothing was charged.", "text-zinc-400"],
  };
  const [Icon, title, sub, cls] = map[state];
  return (
    <AuthShell title={title} subtitle={sub}>
      <div data-testid={`payment-status-${state}`} className="flex flex-col gap-6">
        <Icon className={`h-12 w-12 ${cls}`} />
        <Link to={state === "paid" ? "/dashboard/customize" : "/dashboard/store"} className="btn-pink w-full" data-testid="payment-continue-button">{state === "paid" ? "use it now" : "back to store"}</Link>
      </div>
    </AuthShell>
  );
}
